export enum TaxStatus {
    Taxable = 'Taxable',
    TaxExempt = 'Tax Exempt',
}
